import React from 'react';

import logoWhite from './Logo_pilotage_ALLwhite.svg';
import logo from '../../assets/img/Logo_pilotage_black.svg';
import logoSmall from './app-logo-small.svg';
import styles from './Logo.module.css';

type LogoProps = {
  className?: string;
  small?: boolean;
  width: number;
  height: number;
  url?: string;
  alt?: string;
  whiteBaseline?: boolean;
};

export const Logo: React.FC<LogoProps> = ({
  className,
  small = false,
  width,
  height,
  url,
  alt,
  whiteBaseline,
}) => (
  <div className={className}>
    {small ? (
      <img
        className={url ? styles.container : ''}
        src={url ? url : logoSmall}
        width={width}
        height={height}
        alt={alt ? alt : 'logo'}
      />
    ) : whiteBaseline ? (
      <img
        className={url ? styles.container : className}
        src={url ? url : logoWhite}
        width={width}
        height={height}
        alt={alt ? alt : 'logo'}
      />
    ) : (
      <img
        className={url ? styles.container : className}
        src={url ? url : logo}
        width={width}
        height={height}
        alt={alt ? alt : 'logo'}
      />
    )}
  </div>
);
